export const getPlaceHolder = (fullName) => {
  const nameArray = fullName.split(' ');
  const firstName = nameArray[0];
  const lastName = nameArray[nameArray.length - 1];
  return firstName?.charAt(0)?.toUpperCase() + lastName?.charAt(0)?.toUpperCase();
};
